import { FC, useState, useRef } from 'react';
import { useTranslation } from 'src/i18n';
import {
  Box,
  Input,
  IconButton,
  Tooltip,
  Divider,
  InputProps,
} from 'material-hu';
import { ArrowBack as ArrowBackIcon } from 'material-hu/icons';
import { Close as CloseIcon } from 'material-hu/icons';
import SearchIcon from 'src/icons/Search';

export type SearchBarProps = InputProps & {
  onChange?: (param) => void;
  query?: string;
  placeholder?: string;
  withoutDivider?: boolean;
  isChat?: boolean;
};

const SearchBar: FC<SearchBarProps> = props => {
  const {
    onChange,
    query,
    placeholder,
    inputProps,
    withoutDivider,
    isChat = false,
    sx = {},
  } = props;

  const [isFocused, setIsFocused] = useState(false);

  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleFocusInput = () => {
    setIsFocused(true);
  };

  const handleBlurInput = () => {
    onChange('');
    setIsFocused(false);
  };

  const handleClearInput = () => {
    onChange('');
  };

  const handleKeyDown = e => {
    if (e.key === 'Escape') {
      handleBlurInput();
      inputRef.current.blur();
    }
  };

  return (
    <>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: 'background.default',
          borderRadius: isChat ? '6px' : 22,
          display: 'flex',
          height: 44,
          px: 2,
          mb: 2,
          mx: 2,
          ...sx,
        }}
        onKeyDown={handleKeyDown}
      >
        {!isFocused && (
          <SearchIcon
            sx={{ ml: 1 }}
            color="action"
            fontSize="small"
          />
        )}
        {isFocused && (
          <Tooltip title={t('GENERAL:BACK')}>
            <IconButton
              aria-label={t('GENERAL:BACK')}
              size="small"
              onClick={handleBlurInput}
            >
              <ArrowBackIcon color="primary" />
            </IconButton>
          </Tooltip>
        )}
        <Box
          sx={{
            flexGrow: 1,
            m: 2,
          }}
        >
          <Input
            inputRef={inputRef}
            inputProps={inputProps}
            fullWidth
            disableUnderline
            onChange={e => onChange(e.target.value)}
            placeholder={placeholder || t('SEARCH')}
            value={query}
            onFocus={handleFocusInput}
          />
        </Box>
        {isFocused && (
          <Tooltip title={t('GENERAL:DELETE')}>
            <IconButton
              aria-label={t('GENERAL:DELETE')}
              size="small"
              onClick={handleClearInput}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      {!withoutDivider && <Divider />}
    </>
  );
};

export default SearchBar;
